import { render, staticRenderFns } from "./MyQnaView.vue?vue&type=template&id=54f0a405&"
import script from "./MyQnaView.vue?vue&type=script&lang=js&"
export * from "./MyQnaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports